import classNames from 'classnames'
import { bool, node } from 'prop-types'

import { productLabelType } from 'views/utils/propTypes'

import './Flag.scss'

const Flag = ({
  label,
  prescription,
  children,
  withIcon,
  nowWidget,
  abo,
  smaller,
  redPointsMultiplier,
  nowLabelGray,
}) => {
  const flagClassname = classNames('a-Flag', {
    'a-Flag--prescription': prescription,
    'a-Flag--nowWidget': nowWidget,
    'a-Flag--abo': abo,
    'a-Flag--smaller': smaller,
    'a-Flag--with-icon': withIcon,
    'a-Flag--redPointsMultiplier': redPointsMultiplier,
    'a-Flag--nowLabelGrey': nowLabelGray,
  })

  return (
    <span className="u-display--inline-block">
      <span className={flagClassname}>
        {label}
        {children}
      </span>
    </span>
  )
}

Flag.propTypes = {
  children: node,
  label: productLabelType.isRequired,
  prescription: bool,
  nowWidget: bool,
  abo: bool,
  withIcon: bool,
  smaller: bool,
  redPointsMultiplier: bool,
  nowLabelGray: bool,
}

Flag.defaultProps = {
  children: null,
  prescription: null,
  nowWidget: null,
  abo: false,
  withIcon: false,
  smaller: false,
  redPointsMultiplier: false,
  nowLabelGray: false,
}

export default Flag
